








import { Component, Vue } from "vue-property-decorator";
import OfertasOmil from "@/components/Web/OfertasOmil.vue";

@Component({
  components: {
    OfertasOmil
  },
  meta: {
    // sets document title
    title: "Ofertas Laborales - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí las ofertas laborales OMIL disponibles para ti."
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class OfertasOmilView extends Vue {
  private mounted() {
    document.title =
      "Ofertas Laborales - Ilustre Municipalidad de Punta Arenas";
  }
}
